import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { useTheme } from '@mui/material';
import MUIButton from '@mui/material/Button';

interface OptionButtonProps {
  children: any;
  handleClick: (args: any) => any;
}

const OptionButton = ({ handleClick, children }: OptionButtonProps) => {
  const theme = useTheme();
  return (
    <MUIButton
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '100%',
        backgroundColor: theme.palette.grey[50],
        padding: { xxs: '1rem', xs: '1.5rem' },
        color: theme.palette.secondary.main,
        fontWeight: 600,
        cursor: 'pointer',
        transition: 'all 0.3s',
        '&:hover': {
          backgroundColor: theme.palette.grey[100],
          scale: 1.03,
        },
        borderRadius: '1rem',
      }}
      endIcon={<ArrowForwardIosIcon color="secondary" />}
      onClick={handleClick}
    >
      {children}
    </MUIButton>
  );
};

export default OptionButton;
